import { useEffect, useState } from "react";

interface Toast {
  id: string;
  msg: string;
  kind: "ok" | "err";
}

// eslint-disable-next-line react-refresh/only-export-components
// Module-level callback so any component can fire a toast without a context.
// Initialized to a no-op so calls before ToastHost mounts don't blow up.
let push: (msg: string, kind?: "ok" | "err") => void = () => undefined;

// eslint-disable-next-line react-refresh/only-export-components
export function toast(msg: string, kind: "ok" | "err" = "ok"): void {
  push(msg, kind);
}

export function ToastHost() {
  const [toasts, setToasts] = useState<Toast[]>([]);
  useEffect(() => {
    push = (msg: string, kind: "ok" | "err" = "ok") => {
      const id = Math.random().toString(36).slice(2);
      setToasts((t) => [...t, { id, msg, kind }]);
      window.setTimeout(
        () => setToasts((t) => t.filter((x) => x.id !== id)),
        2200,
      );
    };
    return () => {
      push = () => undefined;
    };
  }, []);
  return (
    <div className="toast-wrap">
      {toasts.map((t) => (
        <div key={t.id} className={"toast" + (t.kind === "err" ? " err" : "")}>
          <span className="dot" />
          <span>{t.msg}</span>
        </div>
      ))}
    </div>
  );
}
